var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1677070523164,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 21295,
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M485.5 963.8c-0.9 0-1.9-0.1-2.8-0.2-8.5-1.1-15.5-7.3-17.7-15.6L334.4 459.8 30.8 295.3c-7.9-4.3-12.3-13.1-10.9-22 1.4-8.9 8.2-15.9 17.1-17.6L971.1 79.6c4.7-0.9 9.6-0.3 14.1 2.1 0.4 0.2 0.9 0.5 1.3 0.8 4.4 2.8 7.4 6.9 8.9 11.5 0.6 1.9 0.9 3.9 1 5.9 0.1 3.4-0.7 6.9-2.3 10.2-0.2 0.4-0.4 0.8-0.7 1.2L503.9 953.2c-3.9 6.6-10.9 10.6-18.4 10.6zM377.4 456l115.4 431.6L918 156.5 377.4 456zM103.6 286.4l248.8 134.8 497-275.4-745.8 140.6z",
    fill: "#222222",
    "p-id": 21296
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.8 774.3c-4.4 0-8.8-1.4-12.6-4.1-8-5.9-10.9-16.5-6.9-25.6L333.1 437c4.7-10.8 17.2-15.7 28-11 10.8 4.7 15.7 17.2 11 28l-96.4 221.6L377.9 587c8.9-7.7 22.3-6.7 30 2.1 7.7 8.9 6.7 22.3-2.1 30l-173 150.1c-4.1 3.4-9.1 5.1-14 5.1z",
    fill: "#222222",
    "p-id": 21297
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.cee1c88385e22cfe9b3f0179542f5edc.svg";
export { ForwardRef as ReactComponent };